module.exports = __webpack_public_path__ + "img/IMG_9000_L_BlackMatted_MockedUp.2548595e.jpg";